// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EmployeeClassesCode-hashed__wrap__3t_pF","left":"EmployeeClassesCode-hashed__left__kxp-w","right":"EmployeeClassesCode-hashed__right__32qTv"};